<div class="mt-1 mb-2">
    <div *ngIf="!data.customText" class="text-center">
        You are about to close this {{ data.description }}. Are you sure?
    </div>
    <div *ngIf="data.customText" class="text-center">
        {{ data.customText }}
    </div>
</div>
<div>
    <div class="text-center col-12">
        <button
            (click)="onConfirmClick()"
            class="mr-1"
            color="warn"
            mat-flat-button
        >
            {{ data.ok }}
        </button>
        <button (click)="onCancelClick()" mat-stroked-button>
            {{ data.cancel }}
        </button>
    </div>
</div>
